import {
  Box,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import {
  BarChartBase,
  CustomToolTip
} from 'modules';
import { Tooltip } from 'recharts';
import * as ds from './dataService';



export type UsGDPBarChartProps = {};

export const FC = (props: UsGDPBarChartProps) => {
  const { data } = ds.useQuery();
  const theme = useTheme();

  return (
    <Box
      flex='1 1 0'
      display='flex'
      flexDirection='column'
      borderRadius='1rem'
      border={`1px solid ${theme.palette.gray.light20}`}
      minHeight='400px'
      paddingTop='1rem'
      sx={{
        background: `repeating-linear-gradient(35deg,
        ${theme.palette.gray.light05} 8px,
        ${theme.palette.gray.light10} 11px,
        ${theme.palette.gray.light20} 12px,
        ${theme.palette.gray.light10} 13px
      )`
      }}
    >
      <Stack
        direction='row'
        paddingLeft='1rem'
        paddingBottom='.75rem'
      >
        <Typography
          variant='chartTitle'
        >gross domestic product
        </Typography>
      </Stack>


      <BarChartBase.FC
        data={data}
        toolTip={(
          <Tooltip
            cursor={{
              fill: 'transparent'
            }}
            offset={-15}
            content={(
              <CustomToolTip.FC
                type='GDP'
                active={true}
                label='name'
                payload={data}
              />
            )}
          />
        )}
      />

    </Box>
  );
};
